export default function searchTagsService($http, RESOURCES) {
  const tags = '/search_tags';

  return {
    updateMerchantTags,
    getAllTags,
    getMerchantTags,
  };

  function getAllTags() {
    return $http.get(RESOURCES.TAGS);
  }

  function getMerchantTags(id) {
    return $http.get(RESOURCES.MERCHANT + '/' + id + tags);
  }

  function updateMerchantTags(id, searchTags) {
    return $http.put(RESOURCES.MERCHANT + '/' + id + tags, { searchTags });
  }
}



// WEBPACK FOOTER //
// ./src/app/common/tags/searchTags.service.js